<template>
  <div>
    <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" :model="rulesForm">
      <vue-dividing-line title="基本設定"></vue-dividing-line>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="題目編號" prop="question_no">
            <el-input v-model="rulesForm.question_no" placeholder="請輸入題目編號"></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="語言" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇語言">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="分數" prop="score"> 
            <el-input-number v-model="rulesForm.score" controls-position="right" :min="1" placeholder="請輸入分數"></el-input-number>
          </el-form-item
        ></el-col>
        <!-- <el-col :span="12">
          <el-form-item label="難易程度">
            <el-select v-model="rulesForm.level" placeholder="請選擇難度">
              <el-option v-for="(item, idx) in level" :key="idx"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item
        ></el-col> -->
      </el-row>
      <vue-dividing-line title="問題"></vue-dividing-line>
      <el-form-item label="問題" prop="title">
        <Tinymce v-model="rulesForm.title" ref="Tinymce"></Tinymce>
      </el-form-item>
      <vue-dividing-line title="選項及答案"></vue-dividing-line>
      <el-row type="flex" :gutter="20">
        <el-col :span="12">
          <div>左欄</div>
          <div v-for="(item, index) in left" :key="index">
            <div class="required">選項 {{ index + 1 }}</div>
            <el-row>
              <el-col :span="4">顯示方式 </el-col>
              <el-col :span="9">
                <el-radio-group v-model="item.type">
                  <el-radio label="text">文字</el-radio>
                  <el-radio label="image">圖片</el-radio>
                </el-radio-group></el-col
              >
            </el-row>
            <div v-if="item.type == 'text'" class="block">
              <div class="label">文字 </div>
              <el-input v-model="item.textValue"  placeholder="請輸入文字"></el-input>
              <div v-if="!item.textValue && rules_switch" class="prop-tips">請輸入文字</div>
            </div>
            <div v-else class="block">
              <div class="label">圖片 </div>
              <upload :placeholder="rulesForm.img_url || '請選擇問題圖片'" @childByValue="url => onUploadSuccessChoice(url, item)"></upload>
              <div class="img-box" v-if="item.imgValue">
                <div class="close" @click="item.imgValue = ''"></div>
                <img :src="item.imgValue" />
              </div>
              <div v-else-if="rules_switch" class="prop-tips">請選擇圖片</div>
            </div>

            <div class="block hidden">
              <div class="label">配對左欄選項 </div>
              <el-select v-model="virtual" multiple placeholder="請選擇">
                <el-option label="empty" value="0">
                </el-option>
              </el-select>
            </div>
          </div>

        </el-col>
        <el-col :span="12">
          <div>右欄</div>
          <div v-for="(item, index) in right" :key="index">
            <div class="required">選項 {{ letter[index] }} </div>
            <el-row>
              <el-col :span="4">顯示方式 </el-col>
              <el-col :span="9">
                <el-radio-group v-model="item.type">
                  <el-radio label="text">文字</el-radio>
                  <el-radio label="image">圖片</el-radio>
                </el-radio-group></el-col
              >
            </el-row>

            <div v-if="item.type == 'text'" class="block">
              <div class="label">文字 </div>
              <el-input v-model="item.textValue"  placeholder="請輸入文字"></el-input>
              <div v-if="!item.textValue && rules_switch" class="prop-tips">請輸入文字</div>
            </div>
            <div v-else class="block">
              <div class="label">圖片 </div>
              <upload :placeholder="rulesForm.img_url || '請選擇問題圖片'" @childByValue="url => onUploadSuccessChoice(url, item)"></upload>
              <div class="img-box" v-if="item.imgValue">
                <div class="close" @click="item.imgValue = ''"></div>
                <img :src="item.imgValue" />
              </div>
              <div v-else-if="rules_switch" class="prop-tips">請選擇圖片</div>
            </div>
            
            <div class="block">
              <div class="label">配對左欄選項 </div>
              <el-select v-model="item.tips" multiple placeholder="請選擇">
                <el-option
                  v-for="(its, idx) in left" :key="idx"
                  :label="`選項${its.tips * 1 + 1}`" :value="its.tips">
                  <!-- :label="`選項${chioce[its.tips]}`" :value="its.tips"> -->
                </el-option>
              </el-select>
            </div>

          </div>
        </el-col>
      </el-row>

      <vue-dividing-line title="解答思路"></vue-dividing-line>
      <Tinymce v-model="rulesForm.explanation"></Tinymce>
      <div class="sibmit-button">
        <div class="left">
          <el-button type="info" @click="onSubmit">提交</el-button>
          <el-button type="success" @click="onBack">取消</el-button>
        </div>
        <el-button type="info" @click="preview">預覽題目</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import upload from "@/components/upload";
import Tinymce from "@/components/Tinymce";
import { symbol } from '../plugins/directive'
import rules from "../plugins/validator";
export default {
  directives: {
    symbol
  },
  props: ['formLabelAlign'],
  components: { Tinymce, upload },
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))
    return {
      letter,
      virtual: null,

      // 语言
      lang: [
        {label: '中文', value: 0},
        {label: '英文', value: 1},
      ],
      // 难易程度
      level: [
        {label: '※', value: 1},
        {label: '※※', value: 2},
        {label: '※※※', value: 3},
        {label: '※※※※', value: 4},
        {label: '※※※※※', value: 5},
      ],
      rulesForm: {},
      // rulesForm: {
      //   lang: "",
      //   title: "",
      //   type: 6,
      //   score: 1,
      //   level: 1,
      //   explanation: '',
      //   answers: [],
      //   choices: [],
      //   content: '',
      // },
      rules,
      units: [],
      
      // ligatureList: [
      //   { left: { type: 'text', textValue: '', imgValue: '', tips: '1'}, right: { type: 'text', textValue: '', imgValue: '', tips: '1'}},
      // ],
      left: [
        { type: 'text', textValue: '', imgValue: '', tips: '0', rightTips: []},
        { type: 'text', textValue: '', imgValue: '', tips: '1', rightTips: []},
        { type: 'text', textValue: '', imgValue: '', tips: '2', rightTips: []},
        { type: 'text', textValue: '', imgValue: '', tips: '3', rightTips: []},
        { type: 'text', textValue: '', imgValue: '', tips: '4', rightTips: []},
        { type: 'text', textValue: '', imgValue: '', tips: '5', rightTips: []},
      ],
      right: [
        { type: 'text', textValue: '', imgValue: '', tips: []},
        { type: 'text', textValue: '', imgValue: '', tips: []},
        { type: 'text', textValue: '', imgValue: '', tips: []},
        { type: 'text', textValue: '', imgValue: '', tips: []},
        { type: 'text', textValue: '', imgValue: '', tips: []},
        { type: 'text', textValue: '', imgValue: '', tips: []},
      ],
      rules_switch: false,
    };
  },
  methods: {
    preview() {
      let form = this.handleFromData()
      form.type = 6
      this.$emit('preview', form)
    },
    addChoiceOption(type) {
      let tips = String(this.ligatureList.length + 1)
      this[type].push({ type: 'text', textValue: '', imgValue: '', tips})
    },
    removeChoice(type, idx) {
      this[type].splice(idx, 1);
    },
    onUploadSuccess(url) {
      this.rulesForm.img_url = url;
    },
    onUploadSuccessChoice(url, item) {
      item.imgValue = url
    },
    validator_data() {
      let {left, right} = this,
      leftValues = left.filter(its => {
        if(its.type == 'text' && its.textValue.trim() != '') return its
        if(its.type == 'image' && its.imgValue != '') return its
        return false
      }),
      rightValues = right.filter(its => {
        if(its.type == 'text' && its.textValue.trim() != '') return its
        if(its.type == 'image' && its.imgValue != '') return its
        return false
      })

      this.$refs['ruleForm'].validate(() => {})
      if(leftValues.length < 2) {
        this.$message.error('左欄最少選取倆項')
        return true
      }

      if(rightValues.length < 2) {
        this.$message.error('右欄最少選取倆項')
        return true
      }
      
      return false
    },
    handleFromData() {
      let form = JSON.parse(JSON.stringify(this.rulesForm)),
      { right, left } = this, tempArr = []
      form.answers = []
      form.choices = []
      // 处理數据
      left.forEach((item) => item.rightTips = [])
      right.filter((its, index) => {
        its.tips.filter(item => {
          left[item].rightTips.push(index)
        })

        // 追加 choices 數据
        if(its.type == 'text') tempArr.push({type: 'text', value: its.textValue})
        else tempArr.push({type: 'image', value: its.imgValue})
      })
      form.choices[1] = {value: JSON.stringify(tempArr)}

      // 重置
      tempArr = []

      left.filter(its => {
        form.answers.push({value: its.rightTips.join(',')})

        // 追加 choices 數据
        if(its.type == 'text') tempArr.push({type: 'text', value: its.textValue})
        else tempArr.push({type: 'image', value: its.imgValue})
      })
      form.choices[0] = {value: JSON.stringify(tempArr)}

      let ligatureList = []
      left.filter((its, idx) => {
        ligatureList.push({
          left: {...its},
          right: {...right[idx]}
        })
      })
      
      form.content = JSON.stringify({
        ligatureList
      })

      return form
    },
    // 提交
    onSubmit() {
      if(this.validator_data()) return ;

      let form = this.handleFromData()
      // console.log(form)
      // type, type_display
      this.$emit('save', form, 6, 6)
    },
    // 返回
    onBack() {
      this.$emit('cancel', this.rulesForm)
    },
  },
  created() {
    this.rulesForm = {...this.formLabelAlign}
    console.log(this.left)
  },
  mounted() {
    if(this.rulesForm.id) {
      let {ligatureList} = JSON.parse(this.rulesForm.content)
      
      this.left = []
      this.right = []
      ligatureList.filter((its, ) => {
        its.left.rightTips = []
        this.left.push(its.left)
        this.right.push(its.right)
      })
    }
  }

};
</script>

<style lang="scss" scoped>
.newly-added, .remove-choice {
  display: block;
  width: 120px;
  padding: 10px 0;
  text-align: center;
  font-size: 20px;
  color: #333;
  background-color: #ffb842;
  border-radius: 10px;
  cursor: pointer;
  margin-bottom: 10px;
}
.remove-choice {
  background-color: #EA4C4E;
  color: #fff;
}

.block {
  margin: 10px 0;

  .label {
    font-size: 14px;
    color: rgba(142, 142, 142, 1);
  }
}

.hidden {
  visibility: hidden;
}

</style>